import React from 'react';
import { ReactComponent as RepeatIcon } from '../../assets/icons/repeat.svg';
const RecallOrderTag = () => {
  return (
    <div
      className={`flex items-center gap-x-1 border-[1.5px] rounded-[40px] text-xs leading-[19px] px-4 py-1 text-[#F73B58] bg-[#FEE7EA] border-[#FA8596]`}>
      <RepeatIcon />
      Recalled
    </div>
  );
};

export default RecallOrderTag;
